import React, { useContext } from 'react'
import { textStyles } from './style/style'
import { fetchFeaturedTags } from './featured-tags-slice'
import HorizontalList from './horizontal-list'
import { View, TouchableOpacity, Text, StyleSheet } from 'react-native'
import { MaterialIcons } from '@expo/vector-icons'
import { logoUrl } from '@ecountabl/lib'
import { extra } from './config'
import { useAppDispatch, useAppSelector } from './store'
import DynamicImage from './utility/dynamic-image'
import { ThemeContext } from './utility/context/ThemeContext'
import Haptics from "./utility/haptics"

const FeaturedTags: React.FC = () => {
  const { data, error } = useAppSelector(s => s.featuredTags)

  const dispatch = useAppDispatch()
  const theme = useContext(ThemeContext).theme
  const {textMain, primary, dark, danger} = theme.colors

  if (error) {
    return <View>
      <Text style={[textStyles.body,{color: textMain}]}>
        Oops, there was an error loading loading the best brands for you: {JSON.stringify(error)}
      </Text>
      <TouchableOpacity
        onPress={() => {
          Haptics.impactSoft()
          dispatch(fetchFeaturedTags())
        }}
      >
        <Text style={[textStyles.body, {color: primary}]}>Retry</Text>
      </TouchableOpacity>
    </View>
  }

  return <View style={{gap: 10}}>
    {data.map(t => {
      const header = t.featuredHeader || `${t.label} brands for you`
      return <View key={t._id}>
        {t.imgUrl ? (
          <DynamicImage
            src={logoUrl(t.imgUrl, extra.cdn)}
            alt={undefined}
            style={styles.image}
            fallbackIcon={<MaterialIcons name="image" size={48} color={dark}/>}
            errorIcon={<MaterialIcons name="error-outline" size={48} color={danger}/>}
          />
        ) : null}
        <Text style={[textStyles.h2, {marginBottom: 8, color: textMain}]}>{header}</Text>
        {t.featuredSubtext ? (
          <Text style={[textStyles.body, {marginBottom: 8, color: textMain}]}>
            {t.featuredSubtext}
          </Text>
        ) : null}
        <HorizontalList
          id={`${t._id}-companies`}
          companies={t.companies}
          // always true since these tags, and therefore companies, are always featured
          addlProfileParams={{ source: 'explore', tag: header }}
        />
      </View>
    })}
  </View>
}

export default FeaturedTags

const styles = StyleSheet.create({
  image: {
    height: 'auto',
    width: "100%",
    marginBottom: 8,
    resizeMode: 'contain',
    // admin-defined aspect ratio
    aspectRatio: 5/2,
  },
})